import type { AppProblemModel } from '~/services/api/AppProblemModel'
import { isStoreClosureProblem } from './isStoreClosureProblem'

/**
 * True when `problem` is a closure carrying a scheduled `closed_until` reopen time, as opposed
 * to an indefinite manual closure with no scheduled end.
 */
export function hasClosureReopenTime(problem: AppProblemModel): boolean {
  return isStoreClosureProblem(problem) && problem.params?.['closed_until'] != null
}
